<template>
    <div>
        <LoadingOverlay :show="processingLogout">
            <Sidebar
                :openSidebar="sidebarTriggered"
                :staticSidebarState="staticSidebarOpen"
                @sidebarClosed="sidebarTriggered = false"
                @update:staticSidebarState="staticSidebarOpen = $event"
                @posClicked="handlePosClick"
            />
            <div
                :class="{ 'lg:pl-60': staticSidebarOpen, 'lg:pl-20': !staticSidebarOpen }"
                class="flex min-h-screen min-w-0 flex-col transition-all duration-150 ease-in-out"
            >
                <Topbar
                    @logging-out="processingLogout = true"
                    @logging-out-complete="processingLogout = false"
                />
                <main class="min-w-0 flex-grow pb-4">
                    <slot />
                </main>
                <Footer></Footer>
            </div>
        </LoadingOverlay>
    </div>
</template>

<script setup>
import Sidebar from '@/components/Layout/Main/Sidebar.vue';
import Topbar from '@/components/Layout/Sales/Topbar.vue';
import Footer from '@/components/Layout/Main/Footer.vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import { computed, ref, watch } from 'vue';
import { useAuthStore } from '@/stores/auth-store.js';
import { useConfigurationStore } from '@/stores/configuration-store.js';
import { useRouter } from 'vue-router';

// Breadcrumbs are rendered by SalesLayout/Layout.vue with the page's own content.
const auth = useAuthStore();
const configStore = useConfigurationStore();
const router = useRouter();

const processingLogout = ref(false);
const sidebarTriggered = ref(false);

// The POS folds the sidebar to its rail unless the installation has said it
// should honour the width the user chose (Configurations → Interface & Audit). Elsewhere
// the user's saved preference always wins.
const userPreferredSidebarState = ref(!!(auth?.user && auth.user.sidebar === 'open'));
const posSidebarState = computed(() => (configStore.posSidebarAutoCollapse ? false : userPreferredSidebarState.value));
const staticSidebarOpen = ref(
    router.currentRoute.value.name === 'pos' ? posSidebarState.value : userPreferredSidebarState.value,
);

const handlePosClick = () => {
    userPreferredSidebarState.value = staticSidebarOpen.value;
};

watch(
    () => router.currentRoute.value.name,
    (newRoute, oldRoute) => {
        if (newRoute === 'pos') {
            staticSidebarOpen.value = posSidebarState.value;
        } else if (oldRoute === 'pos') {
            staticSidebarOpen.value = userPreferredSidebarState.value;
        }
    },
);

// The rows arrive after this shell mounts on a cold load, and an operator can
// change the setting while a till sits on the POS; either way the rail follows.
watch(posSidebarState, (open) => {
    if (router.currentRoute.value.name === 'pos') {
        staticSidebarOpen.value = open;
    }
});

watch(
    () => staticSidebarOpen.value,
    (newValue) => {
        if (router.currentRoute.value.name !== 'pos') {
            userPreferredSidebarState.value = newValue;
        }
    },
);
</script>

<style scoped></style>